module.exports = __webpack_public_path__ + "img/icon4.437aef9f.png";